export default __webpack_public_path__ + "static/media/annex3.b15f58cb.png";